import React, { useEffect, useState, Fragment, useRef } from "react";
import { ReportTableContent } from '../../../Common/Table/tableContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const searchData = this.props.searchData;
        const subNames = this.props.contentRowNames;
        const colName = this.props.initialData;
        const summeryValues = this.props.summeryValues;
        const summeryData = this.props.summeryData;

        return (
            <div className="p-2">
                <h3><center><u>Plucking Checklist Report</u></center></h3>
                <center>
                    <div className="row pb-4 pt-4">
                        <div className="col"><b>Group: </b> {searchData.group}</div>
                        <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                        <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                        <div className="col"><b>Date: </b> {searchData.date}</div>
                    </div>
                </center>
                <center>
                    <div className="row pb-4 pt-4" style={{ justifyContent: 'space-between' }}>
                        {searchData.pluckingType == 'GENERAL' ?
                            <div className="card-body width3"><p><b>Full :</b> {summeryValues.full} </p> </div> : null}
                        {searchData.pluckingType == 'GENERAL' ?
                            <div className="card-body width3"><p><b>Half : </b>{summeryValues.half}</p> </div> : null}
                        {searchData.pluckingType == 'GENERAL' ?
                            <div className="card-body width3"><p><b>Bellow : </b>{summeryValues.bellow}</p> </div> : null}
                    </div>
                </center>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Reg No
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Employee Name
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Field
                                </TableCell>
                                {colName.map((item) => (
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>
                                        {item} (Kg)
                                    </TableCell>
                                ))}
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Total
                                </TableCell>
                                {searchData.pluckingType == 'GENERAL' ?
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Mandays
                                    </TableCell> : null}
                                {searchData.pluckingType == 'GENERAL' ?
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Cash Kilo
                                    </TableCell> : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow key={row.registrationNumber}>
                                    <TableCell component="th" align="center" >
                                        {row.registrationNumber}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.firstName}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.fieldName}
                                    </TableCell>
                                    {subNames.map((column) => {
                                        const value = row[column];
                                        return (
                                            <TableCell align='right'>{value == undefined ? '-' : parseFloat(value).toFixed(2)}</TableCell>
                                        );
                                    })}
                                    <TableCell align="center">{parseFloat(row.total).toFixed(2)}</TableCell>
                                    {searchData.pluckingType == 'GENERAL' ?
                                        <TableCell align="center">{row.total < row.configurationValue / 2
                                            ? '0'
                                            : row.total >= row.configurationValue
                                                ? '1'
                                                : '0.5'}</TableCell>
                                        : null}
                                    {searchData.pluckingType == 'GENERAL' ?
                                        <TableCell align="center">{parseFloat(row.total) < parseFloat(row.configurationValue) / 2
                                            ? parseFloat(row.total).toFixed(2)
                                            : (parseFloat(row.total) - parseFloat(row.configurationValue) < 0
                                                ? (parseFloat(row.total) - parseFloat(row.configurationValue) / 2).toFixed(2)
                                                : (parseFloat(row.total) - parseFloat(row.configurationValue)).toFixed(2))}</TableCell> : null}
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="left">
                                    Total
                                </TableCell>
                                {summeryData.map((item) => (
                                    <TableCell style={{ fontWeight: "bold" }} align="right">
                                        {parseFloat(item.value).toFixed(2)}
                                    </TableCell>
                                ))}
                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                    {parseFloat(summeryValues.allTotal).toFixed(2)}
                                </TableCell>
                                {searchData.pluckingType == 'GENERAL' ?
                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                        {parseFloat(summeryValues.totMan).toFixed(1)}
                                    </TableCell> : null}
                                {searchData.pluckingType == 'GENERAL' ?
                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                        {parseFloat(summeryValues.okTot).toFixed(2)}
                                    </TableCell> : null}
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}


